export interface IDonorRecordReview {
    donorAlias: string,
    donorCenter: string,
    recipientAlias: string,
    recipientCenter: string
}